import { REVIEW_VIEW } from "../status";
import { boostReplay } from "./posthog";

interface ReplayBoostRule {
  reason: string;
  sampleRate?: number;
  matches: (pathname: string, search: URLSearchParams) => boolean;
}

// Central boost registry: one rule per flow; boostReplay() directly only for
// state the URL can't see (component state, error boundaries).
const REPLAY_BOOST_RULES: ReplayBoostRule[] = [
  {
    // Bank connect + reauth both run from the credentials bank tab.
    reason: "bank_connect",
    matches: (pathname, search) =>
      pathname.startsWith("/credentials") && search.get("tab") === "bank",
  },
  {
    // Denise review view; the state-only DENIALS filter boosts from ClaimsDashboard.
    reason: "denial_management",
    matches: (pathname, search) =>
      pathname.startsWith("/claims") &&
      search.get("view") === REVIEW_VIEW.DENISE,
  },
];

function applyRouteReplayBoosts(pathname: string, searchString: string): void {
  const search = new URLSearchParams(searchString);
  REPLAY_BOOST_RULES.forEach((rule) => {
    if (rule.matches(pathname.toLowerCase(), search)) {
      boostReplay(rule.reason, rule.sampleRate ?? 1);
    }
  });
}

export { applyRouteReplayBoosts, REPLAY_BOOST_RULES };
